// core
import React, { ReactNode, useContext, useEffect } from "react";
import styles from "./Layout.module.scss";
import cx from "classnames";
import MobileNavMulticompare from "../MobileNavMulticompare/MobileNavMulticompare";
import ProgressBar from "../../../common/components/ProgressBar/ProgressBar";
import { SplitTreatments } from "@splitsoftware/splitio-react";
import { FeatureFlag } from "../../enums/FeatureFlags";
import { QuoteGroupContext } from "../../providers/RootContextProvider";
import AdminNavigation from "../AdminNavigation/AdminNavigation";

type ProgressBarSections = React.ComponentProps<typeof ProgressBar>["progressBarStages"];

interface ILayout {
    hideMenu?: boolean;
    Header?: () => ReactNode;
    isFullWidth?: boolean;
    progressBarCurrentStage?: React.ComponentProps<
        typeof ProgressBar
    >["progressBarCurrentStage"];
}

function buildCompareProgressBar(): ProgressBarSections {
    return [
        { sectionTitle: "Build your quotes", sectionTitleMobile: "Build", id: "build" },
        {
            sectionTitle: "Compare policies",
            sectionTitleMobile: "Compare",
            id: "compare"
        },
        { sectionTitle: "Apply for cover", sectionTitleMobile: "Apply", id: "apply" }
        // { sectionTitle: "Get covered", sectionTitleMobile: "Covered", id: "covered" }
    ];
}

function buildDigitalAdviceProgressBar(): ProgressBarSections {
    return [
        {
            sectionTitle: "Why care?",
            sectionTitleMobile: "Why",
            id: "why"
        },
        {
            sectionTitle: "You & your family",
            sectionTitleMobile: "You",
            id: "you"
        },
        {
            sectionTitle: "Your finances",
            sectionTitleMobile: "Finances",
            id: "finances"
        },
        {
            sectionTitle: "Our Advice",
            sectionTitleMobile: "Advice",
            id: "advice"
        }
    ];
}

const Layout: React.FC<ILayout> = (props) => {
    const { children, Header, isFullWidth, progressBarCurrentStage } = props;
    const { selectors } = useContext(QuoteGroupContext);
    const isFromDigitalAdvice = selectors.hasDigitalAdviceResult();

    useEffect(() => {
        document.body.scrollTop = 0;
    }, []);

    const progressBarStages: ProgressBarSections = isFromDigitalAdvice
        ? buildDigitalAdviceProgressBar()
        : buildCompareProgressBar();

    return (
        <React.Fragment>
            <SplitTreatments names={[FeatureFlag.ProgressBar]}>
                {({ treatments, isReady }) => {
                    if (
                        !isReady ||
                        !progressBarCurrentStage ||
                        treatments[FeatureFlag.ProgressBar].treatment !== "on"
                    )
                        return null;

                    return (
                        <ProgressBar
                            progressBarCurrentStage={
                                isFromDigitalAdvice ? "advice" : progressBarCurrentStage
                            }
                            progressBarStages={progressBarStages}
                        />
                    );
                }}
            </SplitTreatments>
            {selectors.isAdmin() && <AdminNavigation groupId={selectors.getGroupId()} />}
            {/* {!hideMenu && <ProductNavigation className={cx("layout-hidden-mobile")} />} */}
            <MobileNavMulticompare />
            <div
                className={cx([
                    styles["layout"],
                    {
                        [styles["layout-full-width"]]: isFullWidth
                    }
                ])}>
                <div className={cx([styles["content"]])}>
                    <div className={styles["headline"]}>{Header && Header()}</div>
                    {children}
                </div>
            </div>
        </React.Fragment>
    );
};

export default Layout;
